import React from 'react';
import { Link } from 'react-router-dom';
import { FaOptionIcon, moreIcon } from '@europrocurement/l2d-icons';
import { IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { FormaliteDocument } from '@europrocurement/l2d-domain';

export type DocumentTypeListItemActionsProps = {
    item: FormaliteDocument;
};

const DocumentTypeListItemActions: React.FunctionComponent<DocumentTypeListItemActionsProps> =
    function (props) {
        const { item } = props;
        const { id } = item;
        const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
        const open = Boolean(anchorEl);

        const handleClick = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        return (
            <div
                onClick={(e) => {
                    e.stopPropagation();
                }}
                onKeyDown={() => {}}
                role="button"
                tabIndex={0}
            >
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <FaOptionIcon
                        {...moreIcon.props}
                        iconProps={{ style: { fontSize: '16px' } }}
                    />
                </IconButton>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                        'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem onClick={handleClose}>
                        <Link
                            to={`${id}`}
                            target="_blank"
                            style={{ textDecoration: 'none' }}
                        >
                            <Typography sx={{ color: 'text.primary' }}>
                                Ouvrir dans un nouvel onglet
                            </Typography>
                        </Link>
                    </MenuItem>
                </Menu>
            </div>
        );
    };

export default DocumentTypeListItemActions;
